import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import store from "../../stateManagement/store";
import { closeOtpPopup } from "../../stateManagement/actions/validateOtpPopupActions";
import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  TextField,
  TextFieldProps,
  Typography,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import productionImage from "../../assets/image/png/production.png";
import { MuiOtpInput } from "mui-one-time-password-input";
import {
  ChannelkartNetworkGet,
  ChannelkartNetworkPost,
  getNetworkServiceFunction,
} from "../../services/networkService";
import { openPopup } from "../../stateManagement/actions/popupActions";
import "./ValidateOtpPopupCounterSales.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { manageUpdateAccessObj } from "../../features/manageUpdateAccess/manageUpdateAccessTypes";

import {
  TranslationEnum,
  usePortalTranslation,
} from "../../providers/TranslationProvider";
import { Loader } from "../../components/loader/Loader";
import {
  FormDataType,
  getSendOtpRequestBody,
  getVerifyOtpRequestBody,
  getVerifyOtpRequestHeader,
  otpState,
  sendOtpOutletCreation,
  sendVerifyOtp,
} from "./OutletFormUtils";
import ReverseTimer from "../../components/ReverseTimer/ReverseTimer";
import dayjs from "dayjs";

const otpTextFieldsProps: TextFieldProps = {
  style: {
    background: "white",
    borderRadius: "4px",
  },
  inputProps: {
    style: {
      padding: "5px 0",
      color: "#909090",
      fontSize: "20px",
      fontWeight: 700,
    },
  },
};

interface ValidateOtpPopupCounterSalesProps {
  showPopup: boolean;
  onClose: () => void;
  formData: FormDataType;
  setOtpStatus: React.Dispatch<React.SetStateAction<otpState>>;
  setDuplicateOutletsData: React.Dispatch<React.SetStateAction<any>>;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
  resendOtpState: boolean;
  setResendOtpState: React.Dispatch<React.SetStateAction<boolean>>;
  resetForm: () => Promise<void>;
  outletLocationTransformerName?: string;
  // Timeleft: any;
  // setTimeleft: React.Dispatch<React.SetStateAction<any>>
}

const ValidateOtpPopupCounterSales: React.FC<
  ValidateOtpPopupCounterSalesProps
> = ({
  showPopup = false,
  onClose = () => {},
  formData,
  setOtpStatus,
  setDuplicateOutletsData,
  setErrorMessage,
  resendOtpState,
  setResendOtpState,
  resetForm,
  outletLocationTransformerName = "outlet_location_transformer",
  // Timeleft,
  // setTimeleft,
}) => {
  const CUR_COMPONENT = "ValidateOtp";
  const MAX_TIME = 60;
  const { translate } = usePortalTranslation();
  const otpPopupState = useSelector(() => store.getState().otpPopupState);
  const [otp, setOtp] = useState("");
  const [users, setUsers] = useState<manageUpdateAccessObj[]>([]);
  const defaultSelectedOption = {
    phoneNumber: "",
    isAdmin: false,
    countryCode: "",
    userName: "",
  };
  const [selectedUser, setSelectedUser] = useState<manageUpdateAccessObj>(
    defaultSelectedOption
  );
  const [otpGenerated, setOtpGenerated] = useState<boolean>(false);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [verifyLoader, setVerifyLoader] = useState<boolean>(false);
  const [otpLength, setOtpLength] = useState(6);
  const sessionIdRef = useRef<string>("");
  const senderIdRef = useRef<string>("");
  const designation = JSON.parse(localStorage.authContext)?.user?.designation;
  const [Timeleft, setTimeleft] = useState<number>(60);
  const updateOtp = (newValue: string) => {
    setOtp(newValue);
  };

  useEffect(() =>{
    if (showPopup) {
      setTimeleft(60);
    }
  }, [showPopup]);

  async function handleResendOtp() {
    const currentDateString = dayjs().format("YYYY-MM-DD");
    const requestBody = getSendOtpRequestBody(
      formData.mobileNo,
      currentDateString,
      designation
    );
    try {
      const response = await sendOtpOutletCreation(requestBody);
      // const response = {status : 200}
      if (response.status === 200) {
        setTimeleft(60);
        setResendOtpState(false);
      }
    } catch (error: any) {
      const status = error?.response?.status;
      setOtpStatus(otpState.INVALID);
      if (status === 400){
        setErrorMessage(`You can request a new OTP after 1 minute.`);
      } else{
        setErrorMessage("Please Try again later");
      }
    }
  }

  async function handleVerifyOtp() {
    const requestBody = getVerifyOtpRequestBody(
      formData.mobileNo,
      formData.latitude,
      formData.longitude,
      100
    );
    const headerBody = getVerifyOtpRequestHeader(otp);
    try {
      setVerifyLoader(true);
      const response = await sendVerifyOtp(requestBody, headerBody, outletLocationTransformerName);
      if (response.status === 200) {
        const data = response.data.features[0];
        if (response.data.features.length === 0) {
          setOtpStatus(otpState.VALID);
        } else {
          
          
          const outletManagerId =
            data?.extendedAttributes["parent-0-1-id"] ?? 
            data?.extendedAttributes["parent-1-0-id"] ??
            data?.extendedAttributes["distributor"] ?? "";

          if (
            !(
              data?.immediateParent.includes(formData?.salesRepId) &&
              outletManagerId.includes(formData?.managerName)
            )
          ) {
            setDuplicateOutletsData(data);
            setOtpStatus(otpState.VALID);
            setErrorMessage(
              `Outlet already exists with Outlet Code: ${data.outletCode}. Form will be filled with existing outlet details.`
            );
          } else{
            setOtpStatus(otpState.INVALID);
            setErrorMessage(
              `Outlet already exists with Outlet Code: ${data.outletCode}. Please fill the form with new Outlet details.`
            );
            await resetForm();
          }
        }
        onClose();
      }
    } catch (error: any) {
      const status = error?.response?.status;
      if (status === 400) {
        setOtpStatus(otpState.INVALID);
        setErrorMessage("Invalid or expired OTP. Please try again.");
      } else if (status === 422) {
        setOtpStatus(otpState.INVALID);
        onClose();
        setErrorMessage(
          "Multiple outlets found with this mobile number. Please contact support."
        );
      } else if (status === 417) {
        setOtpStatus(otpState.INVALID);
        onClose();
        setErrorMessage("Something went wrong. Please try again later.");
      } else {
        setOtpStatus(otpState.INVALID);

        setErrorMessage(
          "Unexpected error occurred. Please check your connection."
        );
      }
    } finally {
      setOtp("");
      setTimeleft(60);
      setVerifyLoader(false);
    }
  }

  const onTimerEnd = () => {
    setResendOtpState(true);
    setTimeleft(() => 0);
  };

  function renderTimeleft() {
    if (Timeleft > 0) {
      return (
        <ReverseTimer
          className="verify-OTP-Timer-counter-sales"
          initialTime={Timeleft}
          onTimerZero={onTimerEnd}
        />
      );
    } else {
      return <></>;
    }
  }

  const closeModal = () => {
    setOtpGenerated(false);
    onClose();
    setOtp("");
    setShowLoader(false);
  };

  const validateChar = (value: string, index: number) => {
    return !isNaN(Number(value)) && value != " ";
  };

  return (
    <div>
      <Backdrop
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={showPopup}
      >
        {!showLoader ? (
          <>
            <div className="validation_popup_container_counter_sales">
              <div className="otp_popup_cross_container">
                <FontAwesomeIcon
                  className="otp_cross_button"
                  icon={faClose}
                  onClick={closeModal}
                />
              </div>

              <Box
                sx={{
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <label className="validate-otp-popup-label">
                  {" "}
                  {"Please enter OTP sent to Mobile Number: "}
                  <span style={{ color: "rgb(144, 144, 144)" }}>
                    {formData.mobileNo}
                  </span>
                </label>
                <MuiOtpInput
                  TextFieldsProps={otpTextFieldsProps}
                  className="validation_otp_input_counter_sales"
                  id="otp"
                  value={otp}
                  length={otpLength}
                  onChange={updateOtp}
                  validateChar={validateChar}
                />
                <div className="resend-otp-container">
                  <button
                    className={
                      resendOtpState ? "resend-otp-label" : "disable-otp-label"
                    }
                    disabled={!resendOtpState}
                    onClick={resendOtpState ? handleResendOtp : undefined}
                  >
                    {resendOtpState ? "Resend OTP" : "Resend in:"}
                  </button>
                  {showPopup && renderTimeleft()}
                </div>
              </Box>
              <Box
                sx={{ display: "flex", justifyContent: "center", gap: "1rem" }}
              >
                <Button variant="outlined" size="medium" onClick={closeModal} style ={{color: "rgb(196, 76, 54)", border: "1px solid rgb(196, 76, 54)"}}>
                  {"Cancel"}
                </Button>
                <Button
                  disabled={otp.length !== otpLength || verifyLoader}
                  variant="contained"
                  size="medium"
                  onClick={handleVerifyOtp}
                  style={{background: "rgb(0, 198, 177)", border: "1px solid rgb(0, 198, 177)", color: "white"}}
                >
                  {verifyLoader ? (
                    <div className="verify-OTP-circular-progress" style={{justifyContent: "space-between"}}>
                      <CircularProgress size={18} sx={{color: "white"}}/>
                      {"VERIFY"}
                    </div>
                  ) : (
                    <>{"VERIFY"}</>
                  )}
                </Button>
              </Box>
            </div>
          </>
        ) : (
          <>
            <Loader />
          </>
        )}
      </Backdrop>
    </div>
  );
};

export default ValidateOtpPopupCounterSales;
